import React, { memo } from 'react'

const Pagination = ({
  totalPages,
  currentPage,
  onPageChange,
  total = totalPages * 10
}) => {
  const handlePageChange = page => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page)
    }
  }
  const renderPageNumbers = () => {
    const pageNumbers = []
    const maxPagesToShow = 5
    const isTruncated = totalPages > maxPagesToShow
    for (let i = 1; i <= Math.min(2, totalPages); i++) {
      pageNumbers.push(i)
    }
    if (isTruncated && currentPage > 4) {
      pageNumbers.push('...')
    }
    for (
      let i = Math.max(3, currentPage - 1);
      i <= Math.min(totalPages - 2, currentPage + 1);
      i++
    ) {
      pageNumbers.push(i)
    }
    if (isTruncated && currentPage < totalPages - 3) {
      pageNumbers.push('...')
    }
    for (let i = Math.max(totalPages - 1, 3); i <= totalPages; i++) {
      if (i > 2) {
        pageNumbers.push(i)
      }
    }

    return pageNumbers
  }

  const pageNumbers = renderPageNumbers()

  return (
    <div className='flex justify-center px-6 py-2'>
      <nav className='flex flex-row items-center justify-center space-x-2 flex-nowrap'>
        <button
          className='text-[#0F172AB2] text-sm font-semibold'
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}  // Changed from currentPage === totalPages
          title='Prev Page'
        >
          Prev
        </button>

        {pageNumbers.map((page, index) => (
          <button
            key={index}
            className={`flex w-8 h-8 justify-center items-center rounded-md border border-[#D2D2D2]  ${currentPage === page
              ? 'bg-[#EAECEF] text-[#0F172A]'
              : 'text-[#0F172A] bg-[#fff] hover:bg-[#EAECEF]'
              } transition-colors duration-200`}
            onClick={() => handlePageChange(page)}
            disabled={page === '...'}
            title={`Page ${page}`}
          >
            {page}
          </button>
        ))}

        <button
          className='text-[#0F172A] text-sm font-semibold'
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          title='Next Page'
        >
          Next
        </button>
      </nav>
    </div>
  )
}

export default memo(Pagination)
